module.exports = __webpack_public_path__ + "static/media/loading_circle.5572838d.gif";